(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    // B2B: keep the hidden _b2b_price line-item property in sync with the selected variant,
  // so the value added to the cart (and read by the Easy PO PDF) matches the chosen variant.
  (function () {
    function sync() {
      document.querySelectorAll('[data-b2b-price-input]').forEach(function (input) {
        var form = input.closest('form');
        if (!form) return;
        var idInput = form.querySelector('[name="id"]');
        var mapEl = form.querySelector('[data-b2b-price-map]');
        if (!idInput || !mapEl) return;
        var map;
        try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }
        var price = map[idInput.value];
        input.value = price == null ? '' : price;
      });
    }
    document.addEventListener('change', function () { setTimeout(sync, 50); }, true);
    document.addEventListener('click', function () { setTimeout(sync, 80); }, true);
    if (document.readyState !== 'loading') { sync(); }
    else { document.addEventListener('DOMContentLoaded', sync); }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-ean"] && !Shopify.designMode) return;
  try {
    // Keep the displayed EAN in sync with the selected variant (theme fires `variant:update`,
  // which bubbles to document; detail.resource is the variant, with .id).
  (function () {
    function apply(variantId) {
      document.querySelectorAll('[data-ean-block]').forEach(function (el) {
        var s = el.querySelector('script[data-ean-map]');
        if (!s) return;
        var map;
        try { map = JSON.parse(s.textContent); } catch (e) { return; }
        var key = String(variantId);
        if (!Object.prototype.hasOwnProperty.call(map, key)) return; // event for another product
        var val = map[key] || '';
        var valEl = el.querySelector('[data-ean-value]');
        if (valEl) valEl.textContent = val;
        el.style.display = val ? '' : 'none';
      });
    }
    document.addEventListener('variant:update', function (e) {
      var r = e && e.detail && e.detail.resource;
      if (!r || r.id == null) return;
      apply(r.id);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["size-chart"] && !Shopify.designMode) return;
  try {
    (function () {
    function normalize(v) {
      return (v || '').toString().trim().replace(/\s+/g, '').replace(/\//g, '-');
    }

    function syncSizeCharts() {
      document.querySelectorAll('.size-chart').forEach(function (chart) {
        var rows = chart.querySelectorAll('tbody tr[data-size]');
        if (!rows.length) return;

        var sizes = {};
        rows.forEach(function (r) { sizes[r.getAttribute('data-size')] = true; });

        // Collect candidate selected values from the variant picker (radios, selects, aria).
        var candidates = [];
        document.querySelectorAll('input:checked').forEach(function (el) {
          if (!el.closest('.size-chart')) candidates.push(el.value);
        });
        document.querySelectorAll('select').forEach(function (s) {
          if (!s.closest('.size-chart')) candidates.push(s.value);
        });
        document.querySelectorAll('[aria-checked="true"],[data-selected="true"]').forEach(function (el) {
          if (!el.closest('.size-chart')) candidates.push(el.getAttribute('data-option-value') || el.value || el.textContent);
        });

        var selected = null;
        for (var i = 0; i < candidates.length; i++) {
          if (sizes[normalize(candidates[i])]) { selected = normalize(candidates[i]); break; }
        }

        rows.forEach(function (r) {
          var on = r.getAttribute('data-size') === selected;
          r.classList.toggle('size-chart__row--selected', on);
          if (on) { r.setAttribute('aria-current', 'true'); } else { r.removeAttribute('aria-current'); }
        });
      });
    }

    document.addEventListener('change', syncSizeCharts, true);
    document.addEventListener('click', function () { setTimeout(syncSizeCharts, 60); }, true);
    if (document.readyState !== 'loading') { syncSizeCharts(); }
    else { document.addEventListener('DOMContentLoaded', syncSizeCharts); }
  })();
  } catch(e) { console.error(e); }
})();

})();
